import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataTheme(params) {
	return client.get("api/web-referral/data", {
		params: params,
	});
}

function getProductToSell() {
	return client.get("api/options/product-to-sell", {
	});
}

function createTheme (params) {
	return client.post("api/web-referral/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteTheme (params) {
	return client.post("api/web-referral/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataTheme,
	getProductToSell,
	createTheme,
	deleteTheme,
};